import React from "react";

// Provides scroll anchor points with fixed header offset compensation
export default function SectionAnchor({ id, className = '', children }) {
  return (
    <section
      id={id}
      className={`scroll-mt-20 ${className}`}
      aria-labelledby={`${id}-heading`}
    >
      {children}
    </section>
  );
}